import { gql } from "@apollo/client";
import { DocumentType } from "@api/graphql/generated/generated-types";

export interface CompliancePolicyFields {
  id: string;
  entityId: string;
  requiredDocumentTypes: DocumentType[];
  warnedDocumentTypes: DocumentType[];
  excludedDocumentTypes: DocumentType[];
}

export interface GetCompliancePoliciesData {
  driverCompliancePolicies: CompliancePolicyFields[];
}

export interface GetCompliancePoliciesVars {
  courierId: string;
  entityIds: string[];
}

export const GET_COMPLIANCE_POLICIES = gql`
  query GetCompliancePolicies($courierId: ID!, $entityIds: [ID!]!) {
    driverCompliancePolicies(courierId: $courierId, entityIds: $entityIds) {
      id
      entityId
      requiredDocumentTypes
      warnedDocumentTypes
      excludedDocumentTypes
    }
  }
`;

export interface OrderDriverComplianceStatus {
  orderId: string;
  missingRequired: DocumentType[];
  missingWarned: DocumentType[];
}

export interface DriverComplianceCheckData {
  driverComplianceCheck: OrderDriverComplianceStatus[];
}

export interface DriverComplianceCheckVars {
  courierId: string;
  driverId: string;
  orderIds: string[];
}

export const DRIVER_COMPLIANCE_CHECK = gql`
  query DriverComplianceCheck($courierId: ID!, $driverId: ID!, $orderIds: [ID!]!) {
    driverComplianceCheck(courierId: $courierId, driverId: $driverId, orderIds: $orderIds) {
      orderId
      missingRequired
      missingWarned
    }
  }
`;
